import { Box } from '@chakra-ui/react';
import { CustomElement } from '../extensions';
import { aiEvents } from '../events';
import { useTranslation } from 'react-i18next';

export function DailyArticlesReportPrompt() {
  const { t } = useTranslation();

  return (
    <Box
      cursor="pointer"
      opacity={0.6}
      _hover={{ opacity: 1, textDecoration: 'underline' }}
      onClick={() => {
        aiEvents.updateMessage.dispatch(
          slateElement(t('ai.predefinedPrompts.dailyReport')),
        );
      }}
    >
      {t('ai.predefinedPrompts.dailyReport')}
    </Box>
  );
}

function slateElement(t: string): CustomElement[] {
  return [
    {
      type: 'paragraph',
      children: [
        {
          text: t,
        },
      ],
    },
  ];
}
